import $ from 'jquery';
import Swal from 'sweetalert2';
import { loadHiddenBlocks, handleDependentFields } from '../utils/dependentFields.js';

export const userSubscribe = () => {
  // Faz a inscrição
  function subscription(challengeId) {
    $.ajax({
      type: 'POST',
      url: '/efetuar-inscricao/',
      data: {
        challenge_id: challengeId,
        _token: $('meta[name="csrf-token"]').attr('content'),
      },
      dataType: 'json',
      success: function (data) {
        if (data.type === 'success') {
          Swal.fire('Sucesso!', 'Inscrição concluída com sucesso!', 'success').then(function () {
            window.location.reload();
          });
        } else {
          Swal.fire(data.title, data.message, data.type);
        }
      },
    });
  }

  // Chama o formulário de inscrição
  function challengeForm(challengeId) {
    $.ajax({
      type: 'POST',
      url: '/formulario-de-acao/',
      data: {
        challenge_id: challengeId,
        _token: $('meta[name="csrf-token"]').attr('content'),
      },
      dataType: 'json',
      success: function (data) {
        if (data.success) {
          $('body').append(data.html);
        }
      },
    });
  }

  // Remove atributo required dos campos em blocos ocultos ao carregar a página
  loadHiddenBlocks();

  // Abre campos dependentes
  handleDependentFields();

  // Submit do formulário
  $(document).on('submit', '.js-form-modal', function (e) {
    e.preventDefault();

    $.ajax({
      type: 'POST',
      url: '/formulario-de-acao/enviar',
      data: $(this).serialize(),
      dataType: 'json',
      success: function (data) {
        if (data.success) {
          $('#modal-form').remove();
          subscription(data.challenge_id);
        }
      },
    });
  });

  // Evento do botão de participar
  $(document).on('click', '[data-type="participate"]', function (e) {
    e.preventDefault();
    let challengeId = $(this).attr('data-challenge'),
      isForm = $(this).is('[data-form]');

    if (isForm) {
      challengeForm(challengeId);
    } else {
      subscription(challengeId);
    }
  });

  // Evento do botão de desparticipar
  $(document).on('click', '[data-type="disparticipate"]', function (e) {
    e.preventDefault();

    Swal.fire({
      title: 'Você tem certeza que quer deixar de participar desta ação?',
      showCancelButton: true,
      confirmButtonColor: '#4134bb',
      cancelButtonColor: '#fff',
      cancelButtonText: 'NÃO TENHO',
      confirmButtonText: 'SIM, TENHO',
      padding: '50px',
      reverseButtons: true,
      customClass: 'c-new-swal',
    }).then(result => {
      if (result.value) {
        let challengeId = $(this).attr('data-challenge'),
          isInternal = false;

        if ($('body').attr('data-controller') == 'challenges' && $('body').attr('data-action') == 'show') {
          isInternal = true;
        }

        $.ajax({
          type: 'POST',
          url: '/cancelar-inscricao/',
          data: {
            challenge_id: challengeId,
            _token: $('meta[name="csrf-token"]').attr('content'),
          },
          dataType: 'json',
          success: function (data) {
            if (data.type === 'success') {
              window.location.reload();
            } else {
              Swal.fire(data.title, data.message, data.type);
            }
          },
        });
      }
    });
  });
};
